<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <div class="div-query-banner">
              <a-form-item label="系列名称">
                <j-dict-select-tag dictCode="gallery_series_name" v-model="queryParam.seriesnumber" ></j-dict-select-tag>
              </a-form-item>
              <a-form-item label="套路名称">
                <j-input v-model="queryParam.routine" >
                </j-input>
              </a-form-item>
              <a-form-item label="样块名称">
                <j-input v-model="queryParam.sampleplate" >
                </j-input>
              </a-form-item>
              <a-form-item label="基材">
                <j-input v-model="queryParam.basematerial" >
                </j-input>
              </a-form-item>
              <a-form-item label="面材">
                <j-input v-model="queryParam.facematerial" >
                </j-input>
              </a-form-item>
            <a-button class="query-banner-btn" type="primary" @click="searchQuery">查询</a-button>
            <a-button class="query-banner-btn" type="primary" @click="searchReset">重置</a-button>
          </div>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('gis_orangehome_gallery_baseinfo')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{x:1300}"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">
        <template slot="openNewTabSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;"></span>
          <a v-else  @click="handleOpenNewTab(text)"  >打开效果图</a>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <p v-if="!text" style="min-height:50px;"></p>
          <img v-else :src="text" height="50px" alt="图片不存在" @click="onShowPicture(text);" style="min-height:50px;max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <div class="images" v-viewer="{movable: false}"    >
      <img v-show="false" v-for='item in imageListData' :src="item" :key="item">
    </div>
    <gisOrangehomeGalleryBaseinfo-modal ref="modalForm" @ok="modalFormOk"></gisOrangehomeGalleryBaseinfo-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import GisOrangehomeGalleryBaseinfoModal from './modules/GisOrangehomeGalleryBaseinfoModal'
  import JInput from '@/components/jeecg/JInput.vue'

  export default {
    name: "GisOrangehomeGalleryBaseinfoList",
    mixins:[JeecgListMixin],
    components: {
      GisOrangehomeGalleryBaseinfoModal,JInput
    },
    data () {
      return {
        description: 'gis_orangehome_gallery_baseinfo管理页面',
        // 表头
        columns: [
          {
            title:'排序',
            align:"center",
            dataIndex: 'sort',
            width:"100px"
          },
          {
            title:'系列名称',
            align:"center",
            dataIndex: 'series',
            width:"100px"
          },
          {
            title:'套路编号',
            align:"center",
            dataIndex: 'routinenumber',
            width:"100px"
          },
          {
            title:'套路名称',
            align:"center",
            dataIndex: 'routine',
            width:"100px"
          },
          {
            title:'样块编号',
            align:"center",
            dataIndex: 'sampleplatenumber',
            width:"100px"
          },
          {
            title:'样块名称',
            align:"center",
            dataIndex: 'sampleplate',
            width:"180px"
          },
          {
            title:'基材',
            align:"center",
            dataIndex: 'basematerial',
            width:"100px"
          },
          {
            title:'面材',
            align:"center",
            dataIndex: 'facematerial',
            width:"100px"
          },
          {
            title:'样板图片',
            align:"center",
            dataIndex: 'imageurl',
            width:"100px",
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title:'720度效果图',
            align:"center",
            dataIndex: 'url',
            width:"100px",
            scopedSlots: { customRender: 'openNewTabSlot' }
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remarks',
            width:"100px"
          },
          {
            title:'更新者',
            align:"center",
            dataIndex: 'updateBy_dictText',
            width:"100px",
            customRender(text,record) {
              if(text){
                return text
              }else if(record.updateBy){
                return record.updateBy
              }else if(record.createBy_dictText){
                return record.createBy_dictText
              }else if(record.createBy){
                return record.createBy
              }
              return " "
            }
          },
          {
            title:'更新日期',
            align:"center",
            dataIndex: 'updateTime',
            width:"100px",
            customRender:function (text,record) {
              if(text){
                return text
              }else if(record.createTime){
                return record.createTime
              }
              return ""
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            width:"120px",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/jpgallery.base/gisOrangehomeGalleryBaseinfo/list",
          delete: "/jpgallery.base/gisOrangehomeGalleryBaseinfo/delete",
          deleteBatch: "/jpgallery.base/gisOrangehomeGalleryBaseinfo/deleteBatch",
          exportXlsUrl: "/jpgallery.base/gisOrangehomeGalleryBaseinfo/exportXls",
          importExcelUrl: "jpgallery.base/gisOrangehomeGalleryBaseinfo/importExcel",
        },
        dictOptions:{},
        isorter: {
          column: 'sort',
          order: 'desc',
        },
        filters: {},
        imageListData:[]
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      onShowPicture(text){
        if(!text){
          this.$message.error("找不到图片")
        }
        this.imageListData=[text]
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()  
      },
      handleOpenNewTab(newTabs){
        window.open(newTabs,"_blank")
      },
      initDictConfig(){
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .div-query-banner {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    &>*:nth-child(1) {
      min-width: 300px;
      max-width: 340px;
    }

    &>*:nth-child(n+2) {
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n) {
      width: 100px;
    }
  }
</style>